import { useEffect, useState } from "react";
import api from "@/lib/api";

const ROWS_KEY = "sc.quick.rows";
const QUEUE_KEY = "sc.quick.queue";
const USER_KEY = "sc.user";

const read = (k, d) => { try { return JSON.parse(localStorage.getItem(k)) ?? d; } catch { return d; } };
const write = (k, v) => localStorage.setItem(k, JSON.stringify(v));

export const isNetworkError = (e) => !e?.response;

export const cacheUser = (u) => (u ? write(USER_KEY, u) : localStorage.removeItem(USER_KEY));
export const cachedUser = () => read(USER_KEY, null);

export const cacheRows = (date, meal, rows) => { const all = read(ROWS_KEY, {}); all[`${date}|${meal}`] = rows; write(ROWS_KEY, all); };
export const cachedRows = (date, meal) => read(ROWS_KEY, {})[`${date}|${meal}`] || null;

export const enqueueSave = (payload) => {
  const q = read(QUEUE_KEY, []).filter((x) => !(x.date === payload.date && x.meal_type === payload.meal_type));
  q.push({ ...payload, queued_at: new Date().toISOString() });
  write(QUEUE_KEY, q);
  return q.length;
};
export const queueSize = () => read(QUEUE_KEY, []).length;

export async function flushQueue() {
  const q = read(QUEUE_KEY, []);
  if (!q.length) return { sent: 0, left: 0 };
  let sent = 0;
  const left = [];
  for (const item of q) {
    try { await api.post("/daily-entries/save", { date: item.date, meal_type: item.meal_type, entries: item.entries }); sent++; }
    catch (e) { if (isNetworkError(e)) left.push(item); }
  }
  write(QUEUE_KEY, left);
  return { sent, left: left.length };
}

export function useOnline() {
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => {
    const on = () => setOnline(true), off = () => setOnline(false);
    window.addEventListener("online", on); window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);
  return online;
}
